import '../partials/product/search/search-list/search-list';
import '../partials/product/wishlist/wishlist-add/wishlist-add';
